.report-container {
  background: var(--main-background);
  width: 100%;
  max-width: 1200px;
  min-width: 650px;
  margin: 0 auto;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 8px;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
}

.report-title-section {
  flex: 1;
}

.report-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.report-subtitle {
  font-size: 16px;
  color: var(--body-text);
  margin: 0;
}

.report-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

@media (max-width: 600px) {
  .report-container {
    padding: 10px 15px;
    min-width: unset;
    width: 100%;
  }
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  flex-direction: column;
  gap: 16px;
}

.backLink {
  text-transform: none;
  color: var(--icon-color);
  text-decoration: none;
}

.backLink:visited {
  color: var(--icon-color);
}

@media print {
  .report-actions {
    display: none !important;
  }
}
